module.exports = __webpack_public_path__ + "static/media/news_arrow.c281e926.svg";